export default __webpack_public_path__ + "static/logo-90f38b6b7d44be684011f343d22d6e9f.png";